import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { auth } from '../firebase';
import { signInWithEmailAndPassword } from 'firebase/auth';

function Login() {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const navigate = useNavigate();

    const handleLogin = async (e) => {
        e.preventDefault(); // Impede o recarregamento da página
        setError(''); // Limpa erros anteriores
        if (!email || !password) {
            setError('Por favor, preencha o e-mail e a senha.');
            return;
        }

        try {
            await signInWithEmailAndPassword(auth, email, password);
            navigate('/'); // Redireciona para a página principal após o login
        } catch (err) {
            console.error(err);
            // Melhora a mensagem de erro para o usuário
            switch (err.code) {
                case 'auth/user-not-found':
                case 'auth/wrong-password':
                case 'auth/invalid-credential':
                    setError('E-mail ou senha incorretos.');
                    break;
                case 'auth/invalid-email':
                    setError('Formato de e-mail inválido.');
                    break;
                default:
                    setError('Ocorreu um erro ao fazer login. Tente novamente.');
                    break;
            }
        }
    };

    return (
        <div className="login-page">
            <div className="login-card">
                
                <h2>Sistema de Cotações</h2>
                <p>Acesse com suas credenciais</p>

                <form onSubmit={handleLogin}>
                    <div className="input-group">
                        <input
                            type="email"
                            placeholder="Seu e-mail"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                        />
                    </div>
                    <div className="input-group">
                        <input
                            type="password"
                            placeholder="Sua senha"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                        />
                    </div>
                    
                    {error && <p className="login-error">{error}</p>}
                    
                    <button type="submit" className="login-button">Entrar</button>
                </form>
            </div>
        </div>
    );
}

export default Login;
